import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';

import Chapter from './container';


export default class ChapterWrapper extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  render() {
    const { match } = this.props;
    const { match: { params: { programCode } } } = this.props;

    return (
      <Chapter key={programCode} programCode={programCode} match={match} />
    );
  }
}
